<script setup>
import { useLoadingStore } from '@/store/loading-store';
import ProgressSpinner from 'primevue/progressspinner';
import { computed } from 'vue';

const loading = computed(() => useLoadingStore().loading);
</script>

<template>
    <teleport to="body">
        <div v-if="loading" class="loading-overlay">
            <ProgressSpinner style="width: 90px; height: 90px" strokeWidth="7" fill="transparent" animationDuration="1.5s" aria-label="Custom ProgressSpinner" />
        </div>
    </teleport>
</template>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
</style>
